export default __webpack_public_path__ + "static/media/126.fb1f1ab5.jpg";